import { useAtom } from "jotai";
import { useEffect } from "react";

import { FALLBACK_TIMEZONE, timezoneAtom } from "src/store/timezoneStore";

function detectSystemTimezone(): string {
  if (typeof window === "undefined") {
    return FALLBACK_TIMEZONE;
  }
  const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return resolved || FALLBACK_TIMEZONE;
}

// 사용자 PC 의 시스템 timezone(IANA TZID) 을 atom 으로 구독하는 hook.
//
// 마운트 시 부수효과: `detectSystemTimezone()` 결과가 현 atom 과 다르면 atom 을 갱신한다.
// 따라서 본 hook 호출은 read-only 가 아니라, 다른 컴포넌트의 `useTimezone()` / `useAtom(timezoneAtom)`
// 구독자에게도 자동 감지 결과를 전파한다.
//
// 사용자에 의한 수동 설정 기능이 없는 현 시점에서는 반환값은 IANA TZID 문자열만 노출한다.
// 수동 설정 기능이 추가되면 이 hook 의 반환 타입에 그 분기 정보를 추가한다.
export function useTimezone(): { timezone: string } {
  const [timezone, setTimezone] = useAtom(timezoneAtom);

  useEffect(() => {
    const detected = detectSystemTimezone();
    if (detected !== timezone) {
      setTimezone(detected);
    }
  }, []);

  return {
    timezone,
  };
}
